import {
    clearBetting,
    setBetting,
    setCountDown,
    setCurrentBet,
    setCurrentBetLoading,
    setCurrentDraw,
    setDraw,
    setListDraw,
    setLoading,
    setStatistic
} from './reducer';
import {getCurrentBet, getDraw, getListDraw, getStatistic, postBet} from "./_requests";
import {BetModel, DrawModel, initCurrentBetParam, initStatisticParam, StatisticParam, TDraw} from "./_models";
import {showToastBetSuccess, showToastError} from "../../../../_kiloit/helpers/Toast";
import {useDispatch} from "react-redux";
import {useBalance} from "../../balance/action";
import {AnyAction, ThunkAction} from "@reduxjs/toolkit";
import {RootState} from "../../../redux/store";
import {scrollTop} from "../../../../_kiloit/helpers/utils";
import {toast} from "react-toastify";
import {getCSize} from "../../../../_kiloit/helpers/storage";
import {getClient} from "../../../services/SocketService";

const useGame = () => {
    const dispatch = useDispatch();
    const {fetchBalance} = useBalance();
    // get socket client instant


// post api create betting
    const postBetting = async (payload: BetModel) => {
        return postBet(payload).then(res => {
            dispatch(setBetting(payload.items[0]));
            fetchBalance();
            fetchCurrentBet({size: getCSize(), tableId: payload.tableId});
            showToastBetSuccess("Bet Success.", {
                position: toast.POSITION.TOP_CENTER
            });
            scrollTop("current-bet-report")
            return res
        }).catch((error) => {
            showToastError(error.response.data.message, {
                position: toast.POSITION.TOP_CENTER
            })
            return error
        })
    }


// fetch api current draw
    const fetchCurrentDraw = (params: number | undefined, isRefresh = true) => {
        dispatch(setLoading(true))
        getDraw(params).then(res => {
            const data = res;
            if (!isRefresh) {
                dispatch(setCountDown(data.currentDraw!.countDown))
                return;
            }
            dispatch(setDraw(data));
            checkDraw(data.currentDraw!);
        })
    }

// start countdown timer
//     const startCountDown = (dispatch: any, countDown = 0) => {
//         if (countDown <= 0) return;
//         clearInterval(countDownInv);
//         dispatch(setCountDown(countDown));
//         countDownInv = setInterval(() => {
//             countDown--;
//             if (countDown <= 10) playAudio("/countdown.mp3");
//             if (countDown === 0) playAudio("/goodluck.mp3");
//             if (countDown <= 0) clearInterval(countDownInv);
//             dispatch(setCountDown(countDown < 0 ? 0 : countDown));
//         }, 1000);
//     }


// check draw status if release or open
    const checkDraw = (currentDraw: TDraw) => {
        if (currentDraw?.countDown! > 0 && currentDraw?.status === 0) {
            dispatch(clearBetting());
            dispatch(setCountDown(currentDraw.countDown))
        }
        dispatch(setCurrentDraw(currentDraw));
    }


// fetch api statistic
    const fetchStatistic = (tableId: number, params: StatisticParam = initStatisticParam) => {
        getStatistic(tableId, params).then(res => {
            dispatch(setStatistic(res));
        });
    }

// fetch api current betting
    const fetchCurrentBet = (params = {}) => {
        dispatch(setCurrentBetLoading(true));
        getCurrentBet({...initCurrentBetParam, ...params}).then(res => {
            dispatch(setCurrentBet(res));
        });
    }


// fetch api list all game tables
    const fetchListDraw = async () => {
        dispatch(setLoading(true));
        const res = await getListDraw();
        dispatch(setListDraw(res));
        return res;
    }


// start subscription by topic & return callback message
    const subscriptionSocket = (topic: string, callback: ((arg0: any) => any) | undefined) => {
        const client = getClient();

        return client?._startSubscribe(topic, (ms: any) => {
            callback && callback(ms);
        });
    }

// check and updated list table by tableId from socket
    const checkListDrawAndUpdate = (cd: any): ThunkAction<void, RootState, unknown, AnyAction> => {
        return async (dispatch, getState) => {
            const ld = getState().gameState.game.listDraw;
            let listDraw = ld.map((draw: DrawModel) => {
                if (draw.tableId === cd.tableId) {
                    return cd;
                }
                return draw;
            });
            dispatch(setListDraw(listDraw));
        }
    }

// unSubscription socket
    const unsubscriptionSocket = () => {
        const client = getClient();
        client?._unsubscribe()
    };


    return {
        postBetting,
        checkDraw,
        fetchCurrentDraw,
        fetchStatistic,
        fetchCurrentBet,
        fetchListDraw,
        subscriptionSocket,
        unsubscriptionSocket,
        checkListDrawAndUpdate,
    }
}

export {
    useGame
}
